import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=17410340&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=js"
export * from "./MemberDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=17410340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17410340",
  null
  
)

export default component.exports